import { arrayOf, string } from 'prop-types';
import React from 'react';
import AmpSocialShare from '../AmpSocialShare';

function AmpPageActions(props) {
  const {
    placement,
    postImage,
    postTitle,
    postUrl,
    resourceId,
    disable
  } = props;
  return (
    <div
      className={`AmpPageActions ${
        placement ? `AmpPageActions--${placement}` : ''
      }`}
    >
      <AmpSocialShare type="facebook" url={postUrl} />
      <AmpSocialShare type="pinterest" media={postImage} url={postUrl} />
      <AmpSocialShare type="email" title={postTitle} url={postUrl} />
      {disable.includes('comment') === false && (
        <AmpSocialShare type="comments" resourceId={resourceId} url={postUrl} />
      )}
      <style jsx>{`
        .AmpPageActions {
          display: grid;
          grid-template-columns: repeat(4, 40px);
          grid-column-gap: 0.5rem;
        }
      `}</style>
    </div>
  );
}

AmpPageActions.propTypes = {
  placement: string,
  postImage: string,
  postTitle: string,
  postUrl: string.isRequired,
  resourceId: string.isRequired,
  disable: arrayOf(string)
};

AmpPageActions.defaultProps = {
  placement: undefined,
  postImage: undefined,
  postTitle: undefined,
  disable: []
};

export default AmpPageActions;
